<div class="general-container border border-eggplant-100/[0.25] bg-white">
  <div class="header">
    <div class="flex flex-col header-content border-b border-b-eggplant-100/[0.25]">
      <div class="flex flex-row">
        <div *ngIf="info.status !== 9"
          class="prof-container border-r border-r-eggplant-100/[0.25] flex md:flex-col flex-col-reverse">
          <p class="text-l text-eggplant-100/[0.25] font-sans capitalize">{{ 'PROJECT_LIST.PROFITABILITY' | translate }}
          </p>
          <p class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">{{info.profitability |
            number:'1.0-2':'es'}}<span class="text-h300">% TIR</span></p>
        </div>
        <div class="year-container border-r border-r-eggplant-100/[0.25] flex md:flex-col flex-col-reverse">
          <p class="text-l text-eggplant-100/[0.25] font-sans capitalize">{{ 'OVERVIEW_PROJECT.DEAD_LINE' | translate }}
          </p>
          <p *ngIf="info.id !== 162" class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">
            {{info.id !== 130 ?
            info.term : '6,5'}} <span class="text-h300 lowercase">{{ 'OVERVIEW_PROJECT.YEARS' | translate }}</span></p>
          <p *ngIf="info.id === 162" class="text-eggplant-100 uppercase font-sans text-xl md:text-h500 whitespace-nowrap">
            2-50 <span class="text-h300 lowercase">{{ 'OVERVIEW_PROJECT.YEARS' | translate }}</span></p>
        </div>
        <div class="inv-container flex flex-col">
          <p
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels cap-label border border-eggplant-100/[0.4] w-fit">
            <span *ngIf="info.type === 1">{{ 'OVERVIEW_PROJECT.LOAN' | translate }}</span>
            <span *ngIf="info.type === 2">{{ 'OVERVIEW_PROJECT.DEBT' | translate }}</span>
          </p>
          <p *ngIf="info.id !== 143 && info.technology !== 5 && (info.technology !== 4 || !info.rechargePoints || (info.rechargePoints && info.rechargePoints === 0))"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            {{info.power | localeNumber}} MW</p>
          <p *ngIf="info.id !== 143 && (info.technology === 4 && info.rechargePoints && info.rechargePoints > 0)"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            {{info.rechargePoints}} puntos</p>
          <p *ngIf="info.id === 143"
            class="font-sans text-s text-center text-eggplant-100/[0.4] uppercase labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            184 puntos</p>
          <p *ngIf="info.technology === 5"
            class="font-sans text-s text-center text-eggplant-100/[0.4] labels border border-eggplant-100/[0.4] w-fit whitespace-nowrap">
            {{info.technologyUnit}} {{info.technologyAmount}}
          </p>
        </div>
      </div>
      <div *ngIf="info.id === 162" class="w-full flex flex-col !mt-12">
        <div class="flex gap-4">
          <p
            *ngFor="let value of profitabilityOptions"
            class="font-sans text-s text-center uppercase labels cap-label border w-fit hover:cursor-pointer"
            [ngClass]="{
              'text-white border-orange-80 bg-orange-100': realTimeProfitability === value,
              'text-eggplant-100/[0.4] border-eggplant-100/[0.4]': realTimeProfitability !== value
            }"
            (click)="setRealTimeProfitability(value)"
          >
            {{ infoRetree[value].percent }}
          </p>
        </div>
        <div class="flex flex-col rounded-2xl bg-orange-100/[0.5] !mb-6 !pt-6 !pb-8 !px-12 text-white">
            <p class="font-sans text-m"><span class="text-m md:text-l pr-6">{{ infoRetree[realTimeProfitability].percent }}</span> {{ infoRetree[realTimeProfitability].title }}</p>
            <p class="font-sansLight text-s !leading-[1.2]">{{ infoRetree[realTimeProfitability].text }}</p>
        </div>
        <p class="font-sansLight text-s text-eggplant-100/[.40] [&>a]:text-orange-100 [&>a]:font-bold !leading-[1.2]" innerHTML="{{ 'RETREE.INFO' |
          translate }}"></p>
      </div>
    </div>
  </div>
  <div class="subheader flex !pt-24 !pb-16" [ngClass]="{'justify-between' : (originalContributed > 0 && projectStatus > 3) || (info.total > 0 && projectStatus === 3),
    'place-content-end' : !(originalContributed > 0 && projectStatus > 3) || (info.total > 0 && projectStatus === 3),
    'flex-col md:flex-row' : (projectStatus > 4 && projectStatus < 12)}">
    <div class="flex justify-between w-full"
      *ngIf="(originalContributed > 0 && projectStatus > 3) || (info.total > 0 && projectStatus === 3)">
      <div class="flex flex-col content-between">
        <p *ngIf="projectStatus === 3" class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' |
          translate }}</p>
        <p *ngIf="projectStatus > 3" class="font-sans text-m text-eggplant-100/[0.4]">{{
          'PROJECT_LIST.CONTRIBUTED_LABEL' | translate }}</p>
        <p *ngIf="projectStatus === 3"
          class="font-sansMedium text-2xl xl:text-3xl !leading-none w-fit whitespace-nowrap"
          [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}">
          {{info.total | localeNumber}} €</p>
        <p *ngIf="projectStatus > 3" class="font-sansMedium text-2xl xl:text-3xl !leading-none w-fit whitespace-nowrap"
          [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}">
          {{originalContributed | localeNumber}} €</p>
      </div>

      <div class="text-right flex flex-col content-between w-full"
        *ngIf="info.total_official && info.total_official > 0">
        <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }} {{
          'PROJECT_LIST.OBJ_MIN' | translate }}</p>
        <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">
          <span *ngIf="!minExceeded">{{ info.total_official | number:'1.0-2':'es'}} €</span>
          <span *ngIf="minExceeded">{{ 'PROJECT_LIST.OBJ_RESERCHED' | translate }}</span>
        </p>
      </div>

      <div class="text-right flex flex-col content-between w-full"
        *ngIf="!(info.total_official && info.total_official > 0) && ((projectStatus === 4 || projectStatus === 12))">
        <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'PROJECT_LIST.OBJECTIVE' | translate }}</p>
        <p class="font-sansMedium text-l xl:text-xl text-eggplant-100 !leading-none">{{ this.barData.total_parse }}</p>
      </div>

      <!--<div class="text-right flex flex-col content-between"
        *ngIf="((projectStatus === 4) || (projectStatus === 12)) && this.daysR <= 7">
        <p class="font-sans text-m text-eggplant-100/[0.4]">{{ 'FORMALITIES.LIMIT_DATE' | translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none">{{ this.limitDate }}</p>
      </div>-->
      <div class="text-right flex flex-col content-between w-full"
        *ngIf="(projectStatus !== 4) && (projectStatus !== 12)">
        <p class="font-sans text-m text-eggplant-100/[0.4]"
          *ngIf="(projectStatus > 4 && projectStatus < 12 && projectStatus !== 9 &&  projectStatus !== 15)">{{
          'OVERVIEW_PROJECT.STATUS' | translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none"
          *ngIf="(projectStatus > 4 && projectStatus < 12 && projectStatus !== 9 && projectStatus !== 15)">{{
          'OVERVIEW_PROJECT.FINANCIED' | translate }}</p>
        <p class="font-sansMedium text-2xl xl:text-3xl text-eggplant-100 !leading-none"
          *ngIf=" projectStatus === 9 && projectId === 17">{{ 'PROJECT_LIST.SHOLD' | translate }}</p>
        <p *ngIf="projectStatus === 3 && info.total_official > 0" class="font-sans text-m text-eggplant-100/[0.4]">{{
          'PROJECT_LIST.OBJECTIVE' | translate }} {{ 'OVERVIEW_PROJECT.MIN' | translate }}</p>
        <p *ngIf="projectStatus === 3 && info.total_official > 0"
          class="font-sansMedium text-2xl xl:text-3xl !leading-none  text-right"
          [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}">
          {{info.total_official | localeNumber}} €</p>
      </div>
    </div>
  </div>

  <div *ngIf="(projectStatus === 4 || projectStatus === 12 || projectStatus === 15)" class="graphic flex flex-col">
    <div>
      <fun-overview-bar [data]="barData" [hiddeObjetive]="true"
        [hiddeLegend]="!detailProject?.show_priority_groups_timeline"></fun-overview-bar>
    </div>
    <div class="!pt-24">
      <fun-overviiew-status-avatars [yourInvest]="yourInvest" [yourPendingInvest]="yourPendingInvest"
        [investors]="info.investors" [status]="projectStatus"
        [isFlexibleCompensation]="isFlexibleCompensation"></fun-overviiew-status-avatars>
    </div>
    <!-- Tengo que meter un mensaje de que tu inversión blñabla en funcion a tu estado -->
    <div class="flex gap-6 !p-10 !mt-12 rounded-xl bg-[#EAE7E9] border border-gray-10 backdrop-blur-m"
      *ngIf="priorityInvestedMsg !== null && priorityInvestedMsg !== undefined && yourInvest > 0">
      <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
      <p class="font-sans text-s text-left leading-[1.25]">{{ priorityInvestedMsg }}</p>
    </div>
    <!-- Mensaje informativo de tu reserva y grupo -->
    <div class="flex gap-6 !p-10 !mt-12 rounded-xl border backdrop-blur-m"
      *ngIf="reservationMsg"
      [ngClass]="{
        'bg-[#FDE8E8] border-alert text-alert': reservationStatus === 'danger',
        'bg-[#FFF3E0] border-orange-80 text-orange-120': reservationStatus === 'warning',
        'bg-[#E6F4ED] border-[#039755] text-[#039755]': reservationStatus === 'safe'
      }">
      <fun-icon [name]="'info-circle'"
        [style]="'w-16 h-16 stroke-[2px] ' + (reservationStatus === 'danger' ? 'stroke-alert' : reservationStatus === 'warning' ? 'stroke-orange-120' : 'stroke-[#039755]')"></fun-icon>
      <p class="font-sans text-s text-left leading-[1.25]">{{ reservationMsg }}</p>
    </div>

    <div *ngIf="detailProject?.priority_groups?.length" class="flex items-center justify-between w-full gap-12 !mt-12">
      <div class="flex items-center gap-6 cursor-pointer" (click)="togglePriorityList()">
        <fun-icon [name]="'users'" [style]="'w-16 h-16 md:w-24 md:h-24 stroke-[2px] stroke-orange-100'"></fun-icon>
        <span class="font-sans text-m text-left leading-[1.25]">{{ 'OVERVIEW_PROJECT.GROUPS.HOW.TITLE' | translate
          }}</span>
        <fun-icon [name]="listOpened ? 'chevron-up' : 'chevron-down'"
          [style]="'w-16 h-16 md:w-24 md:h-24 stroke-[4px] stroke-orange-100'"></fun-icon>
      </div>
      <div class="flex gap-6 cursor-help has-tooltip">
        <p class="font-sans text-s text-left leading-[1.25]">{{ 'OVERVIEW_PROJECT.GROUPS.HOW.TXT' | translate }}</p>
        <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100'"></fun-icon>
        <span
          class="font-sans text-s rounded shadow-lg !py-4 !px-6 bg-eggplant-100 text-cream-100 leading-[1.2] -mt-64 tooltip">{{
          'OVERVIEW_PROJECT.GROUPS.HOW.TOOLTIP' | translate }}</span>
      </div>
    </div>

    <div *ngIf="detailProject?.priority_groups?.length"
      class="flex flex-col relative z-10 w-full justify-between gap-12 !mt-12 overflow-hidden" id="container-list">
      <div *ngFor="let group of detailProject.priority_groups; let i = index; let last = last;"
        class="flex flex-col gap-16 md:gap-6 flex-1 w-full relative group">

        <!-- Content -->
        <div class="flex flex-col w-full mb-0 bg-white/[0.5] border backdrop-blur-md rounded-lg"
          [ngClass]="{'border-gray-10' : !group.isEnabledForUser, 'border-gradient-1' : group.isEnabledForUser}">
          <div class="!py-8 !px-12">
            <div class="flex items-center justify-between gap-12 border-b border-gray-10 !pb-6">
              <div class="flex gap-12">
                <div
                  class="flex flex-shrink-0 w-32 h-32 items-center justify-center rounded-lg border border-gray-10 bg-gray-10/[0.5] relative">
                  <span class="absolute top-[7px] w-6 h-6">
                    <span
                      class="animate-ping absolute top-[6px] inline-flex h-full w-full rounded-full bg-[#ff5c2f] opacity-100"></span>
                  </span>
                </div>
                <div class="flex flex-col flex-1">
                  <h3 class="text-base font-sans text-l leading-[1.2] text-eggplant-80">
                    G{{ group.priority }} · {{ group.name }}
                  </h3>
                  <span *ngIf="detailProject?.postal_code_investment_stages?.length"
                    class="text-s font-sans tracking-wider text-eggplant-100/[0.55]">
                    {{ 'OVERVIEW_PROJECT.GROUPS.DATE.PREFIX' | translate }} <span class="uppercase">{{
                      detailProject?.postal_code_investment_stages[0].start_date | date:'d MMM' }}</span>
                  </span>
                </div>
              </div>
            </div>
            <p class="text-base font-sans text-m leading-[1.2] text-eggplant-80 !pt-6">
              {{ group.description }}
            </p>
          </div>

        </div>
      </div>

      <!-- Content -->
      <div class="flex flex-col w-full mb-0 bg-white/[0.5] border border-gray-10 backdrop-blur-md rounded-lg">
        <div class="!py-8 !px-12">
          <div class="flex items-center justify-between gap-12 border-b border-gray-10 !pb-6">
            <div class="flex gap-12">
              <div
                class="flex flex-shrink-0 w-32 h-32 items-center justify-center rounded-lg border border-gray-10 bg-gray-10/[0.5] relative">
                <span class="absolute top-[7px] w-12 h-12">
                  <span
                    class="absolute top-[2px] inline-flex h-full w-full rounded-full bg-[#FFD43C] opacity-100"></span>
                </span>
              </div>
              <div *ngIf="detailProject?.postal_code_investment_stages?.length" class="flex flex-col flex-1">
                <h3 class="text-base font-sans text-l leading-[1.2] text-eggplant-80">
                  G3 · {{ 'OVERVIEW_PROJECT.GROUPS.GLOBAL' | translate }}
                </h3>
                <span class="text-s font-sans tracking-wider text-eggplant-100/[0.55]">
                  {{ 'OVERVIEW_PROJECT.GROUPS.DATE.GLOBAL_PREFIX' | translate }} <span class="uppercase">{{
                    detailProject?.postal_code_investment_stages[1].start_date | date:'d MMM' }}</span> {{
                  'OVERVIEW_PROJECT.GROUPS.DATE.GLOBAL_SUFFIX' | translate }}
                </span>
                <p class="text-base font-sans text-m leading-[1.2] text-eggplant-80 !pt-6">
                  Puedes reservar tu importe para asegurar posición en la cola e invertir en fase global.
                </p>
              </div>
            </div>
          </div>
          <p class="text-base font-sans text-m leading-[1.2] text-eggplant-80 !pt-6">
            {{ 'OVERVIEW_PROJECT.GROUPS.GLOBAL.DESC' | translate }}
          </p>
        </div>

      </div>
    </div>

  </div>
  <div *ngIf="((projectStatus !== 13 && info.activateInvest) || projectStatus === 14)" class="advise pb-12">
    <fun-new-button *ngIf="(projectStatus === 3)" [buttonType]="btnMain"
      title="{{ 'OVERVIEW.GET_INFORMED' | translate }}" (eventClick)="btnClick('call')" [classExtra]="' !w-full mt-32 '"
      [responsive]="false" [size]="'l'"></fun-new-button>
    <!--Este le deberia de chapar-->
    <fun-new-button [title]="btnInvest" [size]="'xl'"
      [buttonType]="yourReservation && yourReservation > 0 ? 'colorFull' : 'colorFull'"
      (eventClick)="btnClick('invest')"
      *ngIf="projectStatus === 4 || projectStatus === 12 || (projectStatus === 14 && info.available && allowedIncrease)"
      [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    <!---->
    <fun-new-button *ngIf="(projectStatus > 4 && projectStatus < 12)" [title]="btnInvested" [size]="'xl'"
      [buttonType]="'secondaryDark'" (eventClick)="btnClick('marketplace')" [classExtra]="' !w-full '"
      [responsive]="false"></fun-new-button>
    <!---->
    <fun-new-button *ngIf="(projectStatus === 15)" size="xl" [buttonType]="btnMain" [title]="'Reservar inversión'"
      (eventClick)="reserveInvestment()" [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    <fun-new-button *ngIf="(projectStatus === 14 && (!info.available || !allowedIncrease))" [buttonType]="btnMain"
      title="{{ 'OVERVIEW.CAPITAL_INCREASE.READ_MORE' | translate }}" (eventClick)="btnClick('info')"
      [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
    <div class="cancel_invest !pt-8"
      *ngIf="(projectStatus === 4 || projectStatus === 12 || projectStatus === 5 || projectStatus === 15)">
      <fun-new-button *ngIf="info.canCancel === true" buttonType="ghost" [title]="btnCancelInvestment"
        (eventClick)="editInvest()" [classExtra]="' !w-full '" [size]="'m'" [responsive]="false"></fun-new-button>
      <!-- <fun-new-button *ngIf="yourReservation && yourReservation > 0" buttonType="ghost" title="Cancelar reserva"
        (eventClick)="cancelReservaion()" [classExtra]="' !w-full '" [size]="'m'" [responsive]="false"></fun-new-button> -->
      <fun-new-button
        *ngIf="info.canCancel !== true && (!yourReservation || yourReservation === 0) && (projectStatus === 12 || projectStatus === 4 || projectStatus === 15)"
        buttonType="ghost" title="{{ 'OVERVIEW_PROJECT.CALCULATE_B' | translate }}" (eventClick)="calculateB()"
        [classExtra]="' !w-full '" [size]="'m'" [responsive]="false"></fun-new-button>
    </div>
  </div>
  <div *ngIf="(projectId === 41)" class="textLineZuera"></div>
  <div *ngIf="(projectId === 41)">
    <p class="zueraText">* {{ 'DETAIL_PROJECT_BENEFITS' | translate }}</p>
  </div>
  <div *ngIf="(projectStatus === 3 && info.available === true)" class="pb-12">
    <fun-new-button *ngIf="(projectStatus === 3 && info.available === true)" buttonType="colorFull" [title]="btnInvest"
      id="begin-checkout" (eventClick)="btnClick('invest')" [classExtra]="' !w-full '" [responsive]="false"
      [size]="'m'"></fun-new-button>
  </div>
  <div
    *ngIf="projectStatus === 15 || (projectStatus > 4 && projectStatus < 12) || ((contributed > info.total_official) && totalOfficialPercent)"
    class="flex"
    [ngClass]="{'!mt-12 !pt-24 border-t border-t-eggplant-100/[0.4]' : (projectStatus > 4 && projectStatus < 12)}">
    <div class="icon-container">
      <fun-icon [name]="'info-circle'" [style]="'w-24 h-24 stroke-gray-40 stroke-2'"></fun-icon>
    </div>
    <div class="info-container">
      <div *ngIf="(projectStatus > 4 && projectStatus < 12)">
        <p class="font-sansMedium font-medium text-m text-gray-40">{{ 'OVERVIEW_PROJECT.LABEL_INFO_1' | translate }}</p>
        <p class="font-sans text-m text-gray-40">{{ 'OVERVIEW_PROJECT.TXT_INFO_1' | translate }}</p>
      </div>
      <div *ngIf="projectStatus === 15">
        <p class="font-sans text-m text-gray-40">{{ 'OVERVIEW_PROJECT.TXT_INFO_2' | translate }}</p>
      </div>
      <div *ngIf="(projectStatus === 4 || projectStatus === 12) && (contributed > info.total_official)">
        <p class="font-sansMedium font-medium text-m text-gray-40">{{ 'OVERVIEW_PROJECT.LABEL_INFO_1' | translate }}</p>
        <p class="font-sans text-m text-gray-40">{{ 'OVERVIEW_PROJECT.TXT_INFO_3' | translate }}</p>
      </div>

    </div>
  </div>

  <div *ngIf="vinculationMap && (vinculationMap['invest'] !== null || vinculationMap['validation'] !== null)"
    class="flex gap-6">
    <div class="icon-container">
      <fun-icon [name]="'info-circle'" [style]="'w-24 h-24 stroke-gray-40 stroke-2'"></fun-icon>
    </div>
    <div>
      <p *ngIf="vinculationMap['invest'] !== null && vinculationMap['invest'] !== undefined && vinculationMap['invest'] !== ''"
        class="font-sans text-m text-gray-40">{{ 'INFO.VINCULATION_STATUS_1' | translate }}: <span class="uppercase">{{
          vinculationMap['invest'] }}</span></p>
      <p *ngIf="vinculationMap['validation'] !== null && vinculationMap['validation'] !== undefined && vinculationMap['validation'] !== ''"
        class="font-sans text-m text-gray-40">{{ 'INFO.VINCULATION_STATUS_2' | translate }}: <span class="uppercase">{{
          vinculationMap['validation'] }}</span></p>
    </div>
  </div>
</div>

<div *ngIf="info.hasDocuments && projectStatus >= 3">
  <fun-new-document (onClickEvent)="downloadAllDocuments()"></fun-new-document>
</div>